import { LoaderFunction } from "react-router-dom";
import { productsApi } from "src/api/services/productsApi";
import { store } from "src/api/store";

export const pricesLoader: LoaderFunction = ({ params }) => {
  if (params.productId != null) {
    return store
      .dispatch(
        productsApi.endpoints.getPricesByProduct.initiate({
          slug: params.productId,
        }),
      )
      .unwrap();
  }
};
